import axios from 'axios';
import { BaseService } from '@/features/base/api/base.api';

class SalesReceiptService extends BaseService {
  private static instance: SalesReceiptService;

  private constructor() {
    super();
  }

  public static get Instance() {
    return this.instance || (this.instance = new this());
  }

  public all(): Promise<IApi<IDayDetails[]>> {
    return this.get<IDayDetails[]>(`${this.baseUrl}/api/salesreceipts`);
  }

  public forStoreId(id: string): Promise<IApi<IDayDetails[]>> {
    return this.get<IDayDetails[]>(`${this.baseUrl}/api/stores/${id}/records`);
  }

  public delete(storeId: string, date: string): Promise<IApi<number>> {
    return this.deleteItem<number>(`${this.baseUrl}/api/stores/${storeId}/records?date=${date}`);
  }
}

export const salesReceiptService = SalesReceiptService.Instance;
